export const photogallery = {
    methods: {
        getCredits(photoData, component) {          
            this.utmStr = this.$root.unsplashUTM + component
            let unsplashUsernameURL =
            this.$root.unsplashURL + "@" + photoData.user.username + this.utmStr
            let firstName = photoData.user.first_name
            let lastName = photoData.user.last_name
            if (firstName == null) {
                firstName = ""
            }
            if (lastName == null) {
                lastName = ""
            }
            const unsplashUsernameName = `${firstName} ${lastName}`

            const creditObj = {}
            creditObj.username = unsplashUsernameName
            creditObj.url = unsplashUsernameURL

            return creditObj
        },
        
    },
    computed: {
        imageRows() {
            const colNum = 4
            const imgLength = Math.ceil(this.imageArray.length / colNum)
            const returnArray = []
            for (let x = 0; x < colNum; x += 1) {
                returnArray[x] = []
            }

            this.imageArray.map((photo, index) => {
                returnArray[index % colNum].push(photo)
            })

            return returnArray
        }
    },
}
